import script from "./MenuBurger.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBurger.vue?vue&type=script&setup=true&lang=js"

import "./MenuBurger.vue?vue&type=style&index=0&id=49cfa665&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49cfa665"]])

export default __exports__